// extracted by mini-css-extract-plugin
export var container = "_sl-0";
export var table = "_sl-2";
export var tableWrapper = "_sl-1";